// extracted by mini-css-extract-plugin
export default {"container":"vTE2HD36"};